import { Dialog } from 'primereact/dialog'
import React, { useState } from 'react'
import MetasDiariasDialog from './MetasDiariasDialog'

const DiarioMetasDiarias = ({ dialogMetas, onHide, semana, setSemana, date, IdCategoria = 3 }) => {

    return (
        <Dialog visible={dialogMetas} onHide={onHide} maximized={false} closeOnEscape={false}
            style={{ width: '80vw', height: '80vh', minHeight: '760px' }} resizable={false}>
            <div className='salesAnual' style={{ width: '100%', overflow: 'hidden', height: '100%' }}>
                <MetasDiariasDialog semana={semana} setSemana={setSemana} date={date}  IdCategoria= {IdCategoria}/>
            </div>
        </Dialog>
    )
}

export default DiarioMetasDiarias
